<!---新增收款单--->
<template>
  <div class="box-wrap">
    <el-form
      v-if="editData"
      :model="editData"
      ref="editBill"
      :rules="rules"
      label-width="124px"
    >
      <column-box
        v-if="Object.keys(data).length"
        :source="data"
        :list="keyList"
        :column="2"
        labelWidth="100"
      >
        <!-- 付款账户 -->
        <el-form-item
          v-if="optionType === OPTION_TYPE.RECEIVE"
          prop="customerAccount"
          :label="'付款账户' + columnSeparator"
        >
          <el-input
            v-model="editData.customerAccount"
            placeholder="请输入"
            maxlength="20"
            clearable
            v-delete-emoji
          />
        </el-form-item>

          <!-- 收款金额 -->
        <!-- eslint-disable-next-line vue/no-unused-refs -->
        <el-form-item prop="amount" ref="form" :label="moneyKeyName">
          <el-input
            v-number:money
            v-model="editData.amount"
            placeholder="请输入"
            clearable
            maxlength="13"
            v-delete-emoji
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>


        <el-form-item style="height: 40px" prop="completeTime" :label="completeTimeTitle">
          <el-date-picker
            v-model="editData.completeTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择时间"
            clearable
            :picker-options="pickerOptions"
          />
        </el-form-item>

        <el-form-item prop="remarks" :label="`备注${columnSeparator}`">
          <el-input
            v-model="editData.remarks"
            type="textarea"
            placeholder="请输入内容"
            maxlength="500"
            show-word-limit
            v-delete-emoji
          />
        </el-form-item>

        <el-form-item style="height: 90px" prop="photo" :label="photoLabel">
          <UploadCommon
            :isAlone="true"
            :fireTitle="uploadTitle"
            :fileList="uploadData"
            @uploadSuccess="photoSuccess"
            :isShowTitle="false"
            :sizeType="4"
            commonUpload
            group="finance"
            code="finance_pay_agreement_pic"
          />
        </el-form-item>
      </column-box>
    </el-form>
  </div>
</template>
<script>
import { companyProviderDetail, getCustomerDetail } from '@/api/company'
import moment from 'moment'
import { mapState } from 'vuex'

const OPTION_TYPE = {
  // 收款单
  RECEIVE: 1,
  // 付款单
  // eslint-disable-next-line vue/no-unused-properties
  PAY: 2,
}

const METHOD_TYPE = {
  // 新增
  ADD: 1,
  // 编辑
  EDIT: 2,
}

// 配置
const CONFIG = {
  [OPTION_TYPE.RECEIVE]: {
    // 文案
    title: '收款',
    // 表格列
    keyList: [
      { key: 'receivableState', name: '收款状态' },
      { key: 'contentName', name: '收款内容' },
      { key: 'receivableAmount', name: '应收金额' },
      { key: 'receivedAmount', name: '已收金额' },
      { key: 'receivableDate', name: '应收日期' },
      { key: 'plateNo', name: '车牌号' },
      { key: 'customer', name: '付款方名称' },
      { key: 'sourceOrderType', name: '来源类型' },
      { key: 'sourceOrderId', name: '来源单ID' },
    ],
    // 参数key
    paramKey: 'receivableType',
    // 参数ID
    paramId: 'receivableId',
  },
  [OPTION_TYPE.PAY]: {
    title: '付款',
    keyList: [
      { key: 'payState', name: '付款状态' },
      { key: 'payType', name: '付款内容' },
      { key: 'payAmount', name: '应付金额' },
      { key: 'paidAmount', name: '已付金额' },
      { key: 'payDate', name: '应付日期' },
      { key: 'plateNo', name: '车牌号' },
      { key: 'payee', name: '收款方名称' },
      { key: 'sourceOrderType', name: '来源类型' },
      { key: 'sourceOrderId', name: '来源单ID' },
    ],
    paramKey: 'paymentType',
    paramId: 'paymentId',
  },
}

export default {
  name: 'addReceipt',
  props: {
    optionType: {
      type: Number,
      default: OPTION_TYPE.RECEIVE, // 1收款单 2付款单
    },
    type: {
      type: Number,
      default: METHOD_TYPE.ADD, // 1新增  2编辑
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
    this.editData.completeTime = this.data.completeTime || moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
  },
  data() {
    return {
      OPTION_TYPE,
      editData: {
        receivableType: '',
        paymentType: '',
        remarks: '',
        completeTime: '',
        photo: '',
      },
      uploadData: [],
      // eslint-disable-next-line vue/no-unused-properties
      categoryList: [],
      // 时间选择器限制
      pickerOptions: {
        disabledDate: (time) => {
          // 收款单完成时间 不能选择当前日期之后的时间【PKXW-2685】
          return this.optionType === OPTION_TYPE.RECEIVE && time.getTime() > Date.now()
        },
      },
    }
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
    keyList() {
      return CONFIG[this.optionType].keyList
    },
    completeTimeTitle() {
      return this.optionType === OPTION_TYPE.PAY ? `实付日期${this.columnSeparator}` : `${CONFIG[this.optionType].title}单完成时间${this.columnSeparator}`
    },
    uploadTitle() {
      return `${CONFIG[this.optionType].title}单据`
    },
    photoLabel() {
      return `${CONFIG[this.optionType].title}凭证${this.columnSeparator}`
    },
    moneyKeyName() {
      return `${CONFIG[this.optionType].title}金额${this.columnSeparator}`
    },
    rules() {
      const baseRule = {
        paymentType: [{
          required: true,
          message: '不能为空',
          trigger: 'blur',
        }],
        completeTime: [{
          required: true,
          message: '不能为空',
          trigger: 'blur',
        }],
      }
      if (this.optionType === OPTION_TYPE.PAY) {
        return {
          ...baseRule,
          amount: [{
            required: true,
            message: '不能为空',
            trigger: 'blur',
          }],
        }
      }
      return {
        ...baseRule,
        photo: [{
          required: true,
          message: '不能为空',
          trigger: 'blur',
        }],
      }
    },
  },
  mounted() {
    this.freeTypeList.forEach((item) => {
      if (String(item.code) === String(this.data.content)) {
        // eslint-disable-next-line vue/no-mutating-props
        this.data.contentName = item.name
      }
    })

    // 编辑
    if (this.type === METHOD_TYPE.EDIT) {
      this.editData.amount = this.data.amount
      this.editData.remarks = this.data.remarks
      this.editData.completeTime = this.data.completeTime

      const { paramKey } = CONFIG[this.optionType]
      this.editData[paramKey] = this.data[paramKey]

      this.uploadData = this.getEchoUploadFileData(this.data.photo, true)
    }

    const { customerId, customerType, payeeType, payeeId } = this.data
    if (this.optionType === OPTION_TYPE.RECEIVE) {
      if (Number(customerType) === 1) {
        companyProviderDetail({
          id: customerId,
        }).then((res) => {
          const { bankName, accountNo, accountName } = res.data
          this.editData.bankName = bankName
          this.editData.accountNo = accountNo
          this.editData.customerAccount = accountName
        })
      } else if (Number(customerType) === 2) {
        if (!customerId) return
        getCustomerDetail({
          id: customerId,
        }).then((res) => {
          res.data = Object.assign(res.data, res.data.individualCustomerVo, res.data.enterpriseCustomerVo)
          const { bankName, accountNo, accountName } = res.data
          this.editData.bankName = bankName
          this.editData.accountNo = accountNo
          this.editData.customerAccount = accountName
        })
      }
    } else if (this.optionType === OPTION_TYPE.PAY) {
      if (Number(payeeType) === 1) {
        companyProviderDetail({
          id: payeeId,
        }).then((res) => {
          const { bankName, accountNo, accountName } = res.data
          this.editData.bankName = bankName
          this.editData.accountNo = accountNo
          this.editData.customerAccount = accountName
        })
      } else if (Number(payeeType) === 2) {
        if (!payeeId) return
        getCustomerDetail({
          id: payeeId,
        }).then((res) => {
          res.data = Object.assign(res.data, res.data.individualCustomerVo, res.data.enterpriseCustomerVo)
          const { bankName, accountNo, accountName } = res.data
          this.editData.bankName = bankName
          this.editData.accountNo = accountNo
          this.editData.payeeAccount = accountName
        })
      }
    }
  },
  methods: {
    photoSuccess(url) {
      this.editData.photo = JSON.stringify([url])
    },
    // 表单验证
    // eslint-disable-next-line vue/no-unused-properties
    formValidate() {
      return new Promise((resolve, reject) => {
        this.$refs.editBill.validate((valid) => {
          if (valid) {
            const { paramId } = CONFIG[this.optionType]
            // 新增
            if (this.type === METHOD_TYPE.ADD) {
              const _check = (type, value) => {
                const _typeData = {
                  [OPTION_TYPE.RECEIVE]: [
                    'receivableAmount',
                    'receivedAmount',
                    '「收款金额」不能大于「剩余应收金额」',
                  ],
                  [OPTION_TYPE.PAY]: [
                    'payAmount',
                    'paidAmount',
                    '「付款金额」不能大于「剩余应付金额」',
                  ],
                }

                const _value =
                  (this.data[_typeData[type][0]] - this.data[_typeData[type][1]]).toFixed(2)
                if (Number(_value) < Number(value)) {
                  this.$message.error(_typeData[type][2])
                  return false
                }
                return true
              }

              this.editData[paramId] = this.data.id
              const bol = _check(this.optionType, this.editData.amount)
              if (!bol) {
                reject()
              }
            } else if (this.type === METHOD_TYPE.EDIT) {
              // 编辑
              this.editData.id = this.data.id
              this.editData[paramId] = this.data[paramId]
            }

            //  不填提交按完成时间=创建时间=当前时间
            if (this.editData.completeTime === '') {
              this.editData.completeTime = new Date()
            }

            resolve(this.editData)
          } else {
            reject()
          }
        })
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    formResetFields() {
      this.$refs.editBill.resetFields()
    },
  },
  watch: {
    uploadData: {
      handler(val) {
        if (!val.length) {
          this.editData.photo = ''
        }
      },
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
.box-wrap {
  ::v-deep .el-input--small {
    width: 205px;
  }
}
.guide{
  margin-left: 5px;
  cursor: pointer;
}
</style>
